import React, { Component } from "react";
import Paper from "@material-ui/core/Paper";
import Typography from "@material-ui/core/Typography";
import Button from "@material-ui/core/Button";
import FormGroup from "@material-ui/core/FormGroup";
import TextField from "@material-ui/core/TextField";
import Divider from "@material-ui/core/Divider";
import Tooltip from "@material-ui/core/Tooltip";
import { withStyles } from "@material-ui/core/styles";
import { withTranslation } from "react-i18next";
import { getErrorString } from "../display/ErrorStrings";
import PopupMessage from "../components/PopupMessage";
import ConfirmDialog from "../components/ConfirmDialog";

import SubmitIcon from "@material-ui/icons/ArrowDropDownCircleOutlined";

import { AmountFormatCustom } from "../components/AmountFormatCustom";

const styles = (theme) => ({
  root: {
    width: "100%",
    marginTop: theme.spacing.unit * 3,
  },
});

class CCRequest extends Component {
  constructor(props) {
    super(props);
    this.state = {
      errorString: "",
      notifyString: "",
      amount: "",
      payee: "",
      confirm: false,
    };
    this.onClose = this.onClose.bind(this);
    this.onClosePopup = this.onClosePopup.bind(this);
    this.handleConfirm = this.handleConfirm.bind(this);
  }

  onClosePopup(e) {
    this.setState({ errorString: "" });
    this.setState({ notifyString: "" });
    this.setState({ confirm: false });
  }
  onClose(e) {
    e.preventDefault();
    this.props.onClose(e);
  }

  handleConfirm(e, action) {
    this.setState({ confirm: false });
    if (this.props.viewOnly) {
      this.setState({
        errorString: getErrorString(
          "viewOnly.warning",
          "Operation not allowed in support mode."
        ),
      });
      return;
    }
    // confirmed
    if (action === 1) {
      fetch("on_ccprint_submit", {
        method: "POST",
        credentials: "same-origin",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          transit: this.props.accountObject.transit,
          account: this.props.accountObject.account,
          type: this.props.accountObject.accountType,
          rangeId: this.props.accountObject.rangeId,
          amount: this.state.amount,
          payee: this.state.payee,
          secureToken: this.props.secureToken,
        }),
      })
        .then(function (res) {
          if (!res.ok) {
            throw Error(res.status + " (" + res.statusText + ")");
          }
          return res;
        })
        .then((res) => res.text())
        .then((text) => {
          var reply = JSON.parse(text);
          if (!reply.authenticated) {
            this.props.history.push("/expired");
          } else if (reply.error) {
            this.setState({ errorString: reply.errorString });
          } else {
            if (reply.warning) {
              this.setState({ notifyString: reply.warningString });
            } else {
              this.setState({
                notifyString: "Your request has been submitted.",
              });
            }
          }
        })
        .catch((error) => {
          this.setState({
            errorString:
              getErrorString(
                "general.server.status.error",
                "The server responded with a status of "
              ) + error.message,
          });
        });
    }
  }

  handleSubmit(e) {
    if (this.state.amount.length === 0) {
      this.setState({
        errorString: getErrorString(
          "stopPayment.amount.error",
          "Amount is required."
        ),
      });
      return;
    }
    if (this.state.payee.length === 0) {
      this.setState({
        errorString: getErrorString(
          "disposition.payee.error",
          "Payee is required."
        ),
      });
      return;
    }
    this.setState({ confirm: true });
  }

  handleAmount(e) {
    this.setState({ amount: e.target.value });
  }

  handlePayee(e) {
    this.setState({ payee: e.target.value });
  }

  render() {
    let { t } = this.props;
    return (
      <div>
        {this.state.errorString.length > 0 && (
          <PopupMessage
            title={getErrorString("general.error", "Error:")}
            text={this.state.errorString}
            error={true}
            onClosePopup={this.onClosePopup}
          />
        )}
        {this.state.notifyString.length > 0 && (
          <PopupMessage
            title={getErrorString("general.info.title", "Information")}
            text={this.state.notifyString}
            error={false}
            onClosePopup={this.onClose}
          />
        )}
        {this.state.confirm && (
          <ConfirmDialog
            title={t("confirmSubmitAction.label")}
            text={t("submitPrintRequest.label")}
            onCloseConfirm={this.handleConfirm}
          />
        )}

        <Paper elevation={5}>
          <FormGroup row>
            <Typography
              variant="headline"
              color="primary"
              style={{ margin: 25 }}
            >
              {t("newPrintRequest.label")}
            </Typography>
            <TextField
              margin="dense"
              id="amount"
              type="text"
              label={t("checkAmt.label")}
              required
              onChange={(event) => this.handleAmount(event)}
              InputProps={{
                inputComponent: AmountFormatCustom,
              }}
            />
            &nbsp;&nbsp;&nbsp;&nbsp;
            <TextField
              style={{
                width: "40%",
                whiteSpace: "normal",
                wordWrap: "break-word",
              }}
              margin="dense"
              id="payee"
              type="text"
              label={t("payee.label")}
              required
              multiline={true}
              rows={5}
              rowsMax={5}
              onChange={(event) => this.handlePayee(event)}
            />
            <Tooltip title={t("submitPrintReq.tip")}>
              <Button
                onClick={(event) => this.handleSubmit(event)}
                color="primary"
              >
                <SubmitIcon />
                &nbsp;{t("submit.button")}
              </Button>
            </Tooltip>
          </FormGroup>
          <Divider />
        </Paper>
      </div>
    );
  }
}

export default withTranslation()(withStyles(styles)(CCRequest));
